import { migration as initial } from "./001_initial";
import { migration as procurementControl } from "./002_procurement_control";
import { migration as purchaseSuppliers } from "./003_purchase_suppliers";
import { migration as invoiceTables } from "./004_invoice_tables";
import { migration as backfillDebitNoteNumbers } from "./005_backfill_debit_note_numbers";
import { migration as supplierContacts } from "./006_supplier_contacts";
import { migration as backfillPurchaseInvoiceNumbers } from "./007_backfill_purchase_invoice_numbers";
import { migration as ownerDiscriminatorGuards } from "./008_owner_discriminator_guards";
import { migration as accountingInvoiceOwnerTableBackfill } from "./009_backfill_accounting_invoice_owner_tables";
import { migration as legacyInvoiceSourceTableArchive } from "./010_archive_legacy_invoice_source_tables";

export const migrations = [
  initial,
  procurementControl,
  purchaseSuppliers,
  invoiceTables,
  backfillDebitNoteNumbers,
  supplierContacts,
  backfillPurchaseInvoiceNumbers,
  ownerDiscriminatorGuards,
  accountingInvoiceOwnerTableBackfill,
  legacyInvoiceSourceTableArchive,
];
